import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import useFromNowTimer from 'client/hooks/useFromNowTimer';

const SrTimerWarning = ({
  fromDate,
  tresholdSeconds,
  message,
}) => {
  const fromNowTimer = useFromNowTimer({ fromDate });
  const color = tresholdSeconds && fromNowTimer.secondsTotal >= tresholdSeconds
    ? 'orange300'
    : 'blueGreycliff';

  return (
    <SrText
      color={color}
      font='greycliff'
      weight='800'
      fontSize='16px'
      lineHeight='25px'
    >
      {`${message} ${fromNowTimer.timeFormatted}`}
    </SrText>
  );
};

SrTimerWarning.propTypes = {
  fromDate: PropTypes.string,
  message: PropTypes.string,
  tresholdSeconds: PropTypes.number,
};

SrTimerWarning.displayName = 'SrTimerWarning';

export default SrTimerWarning;
